import type { IconData } from '@stacksjs/iconify-core'

export const zoomInFlat: IconData = {
  "body": "<g fill=\"none\"><path fill=\"#2859c5\" fill-rule=\"evenodd\" d=\"M1.5 22C1.5 10.678 10.678 1.5 22 1.5S42.5 10.678 42.5 22c0 3.908-1.094 7.56-2.992 10.669l1.047.87l.157.13c1.517 1.257 3.035 2.515 4.535 3.897c2.114 1.947 2.429 5.044.331 7.194a47 47 0 0 1-.818.818c-2.15 2.098-5.247 1.782-7.194-.331c-1.382-1.5-2.64-3.018-3.898-4.535l-.13-.156q-.432-.524-.87-1.047A20.4 20.4 0 0 1 22 42.5C10.678 42.5 1.5 33.322 1.5 22\" clip-rule=\"evenodd\"/><path fill=\"#8fbffa\" fill-rule=\"evenodd\" d=\"M22 35c7.18 0 13-5.82 13-13S29.18 9 22 9S9 14.82 9 22s5.82 13 13 13\" clip-rule=\"evenodd\"/><path fill=\"#2859c5\" d=\"M24.5 16a2.5 2.5 0 0 0-5 0v3.5H16a2.5 2.5 0 0 0 0 5h3.5V28a2.5 2.5 0 0 0 5 0v-3.5H28a2.5 2.5 0 0 0 0-5h-3.5z\"/></g>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default zoomInFlat
